// @core/api/endpoints/calendar/get_calendar_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarPolicyResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get calendar policy
 * Returns a calendar policy by ID.
 */
export async function GetCalendarPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<CalendarPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<CalendarPolicyResponse>(requestPath, { ...requestOptions });
}
